import * as yup from 'yup';

yup.addMethod<yup.AnySchema>(
  yup.string,
  'nullableNonEmpty',
  function (message = 'formErrorBase.required') {
    return (this as yup.StringSchema)
      .trim()
      .nullable()
      .test(
        'nullable-non-empty',
        message,
        (value: any) => value === null || (typeof value === 'string' && value.trim().length > 0)
      );
  }
);
